import { useState, useEffect, useMemo } from "react";
import { Box, CssBaseline } from '@mui/material';
// import { Box, Container, CssBaseline, Typography } from '@mui/material';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ThemeModeContext } from "./contexts/ThemeModeContext";

import RoutesList from './constants/Routes';
import type { IRoute } from './interfaces/IRoute';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';// , Switch

// import logo from './assets/Usidistrib_logo.png';
import Header from './components/Header';
import Footer from './components/Footer';

export default function App() {

  // Détecter le thème par défaut du navigateur
  // const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const [darkMode, setDarkMode] = useState(mediaQuery.matches); //useState(prefersDark);

  // Écoute les changements du thème système
  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => setDarkMode(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, [mediaQuery]);

  // Exposer une action pour basculer le thème + persister
  const toggleTheme = () => {
    setDarkMode(prev => {
      const next = !prev;
      localStorage.setItem("preferredThemeMode", next ? "dark" : "light");
      return next;
    });
  };

  // Créer le thème avec transition fluide
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          background: {
            default: darkMode ? "#222" : "#FFF",
            paper: darkMode ? "#444" : "#DDD"
          },
          text: {
            primary: !darkMode ? "#222" : "#FFF"
          }
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              body: {
                transition: "background-color 0.3s ease, color 0.3s ease",
              },
            },
          },
        },
      }),
    [darkMode]
  );

  const themeModeContextValue = useMemo(
    () => ({ darkMode, setDarkMode, toggleTheme }),
    [darkMode]
  );

  return (
    <div id="app">
      <Router>
        <ThemeModeContext.Provider value={themeModeContextValue} >
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* <Container sx={{ textAlign: "center", mt: 4 }}> */}

            <Box
              sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Header />

              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                }}
              >
                <Routes>
                  {RoutesList.map((route: IRoute) => <Route path={route.url} key={route.url} element={<route.comp />} />)}
                </Routes>
              </Box>

              <Footer />
            </Box>



          </ThemeProvider>
        </ThemeModeContext.Provider>
      </Router>
    </div>
  );
}

/*
            <Container maxWidth={false} disableGutters>
              <Header />
              <div id="page">
                <Routes>
                  {RoutesList.map((route: IRoute) => <Route path={route.url} key={route.url} element={<route.comp />} />)}
                  {/* <Route path="/les-cours" key="les-cours" element={
                    <h1>Page en construction...</h1>
                    // <CourseProvider> {* Routes utilisant la liste des cours via API *}
                    //   <Courses />
                    // </CourseProvider>
                  }>
                  </Route> *}
                </Routes>
              </div>
              {* <Legend /> *}
              {* <NewLegend /> *}
              {* <Footnote /> *}
            </Container>
            {* Footer en bas à droite *}
            <Footer />
*/

// <ThemeProvider theme={theme}>
//   <CssBaseline />
//   <Container sx={{ textAlign: "center", mt: 4 }}>
//     <Typography variant="h4" gutterBottom>
//       Bienvenue dans un projet de base Usidistrib fait en React + Vite + MUI ! ❤
//     </Typography>

//     <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
//       <img id="logo" src={logo} alt="Usidistrib Logo" width={800} />
//     </Box>

//   </Container>
//   {/* Footer en bas à droite */}
//   <Box
//     sx={{
//       position: "fixed",
//       bottom: 20,
//       right: 20,
//       fontSize: "2rem",
//       cursor: "pointer",
//     }}
//     onClick={() => setDarkMode(!darkMode)}
//   >
//     {darkMode ? "🌙" : "🌞"}
//   </Box>

// </ThemeProvider>
